import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

const FinanceError = ({ history, role }) => {

    return (
        <Card className="text-center">
            <CardBody className="p-5">
                <div className="display-1 text-200 fs-error">400</div>
                <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
                    Configuración del condominio no encontrada.
                </p>
                <hr/>
                <p>
                    Asegurate de que tu condominio tiene los <b> de días de cobro y días de prorroga</b> configurados, si no es el caso, {
                        role === 'manager' ?
                            <>
                                puedes hacerlo haciendo click
                                <Link to="/dashboard/config" className="ml-1">
                                    aquí
                                </Link>
                                .
                            </>
                    : <>dile a tu administrador que lo configure para poder usar las finanzas.</>}
                </p>
                <Button className="btn btn-primary btn-sm mt-3" onClick={() => history.goBack()}>
                    <FontAwesomeIcon icon="arrow-left" className="mr-2" />
                    Volver atrás
                </Button>
            </CardBody>
        </Card>
    )
}

export default withRouter(FinanceError);